import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const FacebookIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "currentColor",
    width: size || '1em',
    height: size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    id: "a_1_",
    fill: "currentColor",
    d: "M1.6,0h17.8C20.3,0,21,0.7,21,1.6c0,0,0,0,0,0v17.8c0,0.9-0.7,1.6-1.6,1.6l0,0H1.6 C0.7,21,0,20.3,0,19.4c0,0,0,0,0,0V1.6C0,0.7,0.7,0,1.6,0z M12,21h3v-9h3V9h-3c-0.1-0.3-0.1-0.9,0-2c-0.1-0.5,0.3-0.9,1-1h2V3 c-1,0-2,0-3,0c-2.7,0.3-3.7,2.3-3,6H9v3h3V21z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "68",
    height: "65"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "68",
    height: "65",
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "currentColor",
    d: "M1.6,0h17.8C20.3,0,21,0.7,21,1.6c0,0,0,0,0,0v17.8c0,0.9-0.7,1.6-1.6,1.6l0,0H1.6 C0.7,21,0,20.3,0,19.4c0,0,0,0,0,0V1.6C0,0.7,0.7,0,1.6,0z M12,21h3v-9h3V9h-3c-0.1-0.3-0.1-0.9,0-2c-0.1-0.5,0.3-0.9,1-1h2V3 c-1,0-2,0-3,0c-2.7,0.3-3.7,2.3-3,6H9v3h3V21z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0,0h68v65H0V0z"
  })));
};
FacebookIcon.displayName = 'FacebookIcon';
export default FacebookIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FacebookIcon.js.map